import { render, staticRenderFns } from "./EditWorkFlow.vue?vue&type=template&id=23fa32e6"
import script from "./EditWorkFlow.vue?vue&type=script&lang=js"
export * from "./EditWorkFlow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports